/**
 * Check if the DOM has fully loaded and run a function
 * @param {function} callback
 */
var interval = setInterval(function() {
	if(document.readyState === 'complete') {
		clearInterval(interval);
		loaded();
	}    
}, 100);
function loaded() {

	// Get element Y position
	let stickyEl = document.querySelector(".sticky-element"),
		elem = document.querySelector(".sticky-element");

	// Set our distance placeholder
	let distance = 0;

	// Loop up the dom
	do {
		// Increase our distance counter
		distance += elem.offsetTop;

		// Set the element to it's parent
		elem = elem.offsetParent;

	} while (elem);
	distance = distance < 0 ? 0 : distance;
	
	if ( $(window).width() < 768) {
		distance -= 60;
	} else {
		distance -= 5;
	}

	// When the user scrolls the page, execute myFunction
	window.onscroll = function() {scrollFunction()};


	let stopElementOffset = document.querySelector('.news-section').clientHeight;

	// Add the sticky class to the stickyEl when you reach its scroll position. Remove "sticky" when you leave the scroll position
	function scrollFunction() {
		let userYScroll = window.pageYOffset;

		if ( userYScroll > 50 ) {
			document.body.classList.add('scrolled');
		} else {
			document.body.classList.remove('scrolled');
		}
		
		// Add sticky class to body when tab selector gets on top of the window
		if (userYScroll >= distance) {
			stickyEl.classList.add("sticky")
		} else {
			stickyEl.classList.remove("sticky");
		}

		// Hide element when hits footer
		let stickyElOffsetFromFooter = userYScroll + stopElementOffset + 1080;
		if ( stickyElOffsetFromFooter >= document.body.clientHeight ) {
			stickyEl.style.opacity = 0;
		} else {
			stickyEl.style.opacity = 1;
		}
	} 
};